import { createContext } from "react";

type SiteStructureSidebarReference = React.MutableRefObject<null> | null;
export const SiteStructureSidebarContext = createContext<
  SiteStructureSidebarReference
>(null);
